import axios from 'axios';
import { toolUtils } from '../../../../utils/toolUtils.js'
import { Tag, Typography, Popconfirm, message, Spin, Modal, Button, Row, Col, Card } from 'antd';
import {
    CloseOutlined,
    CheckCircleOutlined,
    DragOutlined
} from '@ant-design/icons';

export default {
    getConference: async function (props, setFuncMap) {
        try {
            const res = await this.getConferenceByUidAction(props.conferenceUid)
            props.setContentHeader(res.data.name)
            setFuncMap.setIsPageLoading(false)
        } catch (error) {
        }
    },
    getConferenceByUidAction: (conferenceUid) => {
        return axios({
            method: 'GET',
            url: `/conference/${conferenceUid}`,
            headers: {
                "role": "topUser"
            }
        })
    },
    getLecturers: async function (props, setFuncMap) {
        try {
            setFuncMap.setIsContentLoading(true)
            const res = await this.getLecturersAction(props.conferenceUid)
            let result = {}
            res.data.forEach(item => {
                result[item.lang] = item
            })
            setFuncMap.setLecturerMap(result)
            setFuncMap.setIsContentLoading(false)
        } catch (error) {
        }
    },
    getLecturersAction: (conferenceUid) => {
        return axios({
            method: 'GET',
            url: `/conference/${conferenceUid}/lecturer`,
            headers: {
                "role": "topUser"
            }
        })
    },
    updateLecturer: async function (payload, props, setFuncMap) {
        try {
            setFuncMap.setIsContentLoading(true)
            const res = await this.updateLecturerAction(payload, props.conferenceUid)
            setFuncMap.setIsContentLoading(false)
        } catch (error) {
        }
    },
    updateLecturerAction: (payload, conferenceUid) => {
        return axios({
            method: 'POST',
            url: `/conference/${conferenceUid}/lecturer`,
            headers: {
                "role": "topUser"
            },
            data: payload
        })
    },
    getLecturer: async function (props, setFuncMap) {
        try {
            setFuncMap.setIsContentLoading(true)
            const res = await this.getLecturerByIdAction(props.conferenceUid)
            let result = {}
            res.data.forEach(item => {
                result[item.lang] = item
            })
            setFuncMap.setLecturerMap(result)
            setFuncMap.setIsContentLoading(false)
        } catch (error) {
        }
    },
    getLecturerByIdAction: (conferenceUid) => {
        return axios({
            method: 'GET',
            url: `/conference/${conferenceUid}/lecturer`,
            headers: {
                "role": "topUser"
            }
        })
    },
};
